// DE status vocabulary shared by the DE list, the profile header, the Setup sidebar and the
// lifecycle actions. The API's `onboarding` is shown as "Setup": the DE exists but has not gone
// live (its LiteLLM key is not delivered yet, see de-setup.tsx).
import { ApiError } from "@companyos/sdk";
import { Badge } from "@companyos/ui";
import type { DeSummary } from "../../api/types";

export type DeStatus = DeSummary["status"];

export const DE_STATUS_LABELS: Record<DeStatus, string> = {
  onboarding: "Setup",
  active: "Active",
  paused: "Paused",
  retired: "Retired",
  not_deployed: "Not deployed",
};

const TONE = {
  onboarding: "info",
  active: "success",
  paused: "warning",
  retired: "neutral",
  not_deployed: "neutral",
} as const satisfies Record<DeStatus, string>;

export function DeStatusBadge({ status }: { status: DeStatus }) {
  return (
    <Badge variant={TONE[status]} dot data-de-status={status}>
      {DE_STATUS_LABELS[status]}
    </Badge>
  );
}

/** The problem's detail (or title) of a failed call, for inline dialog errors. */
export function problemText(error: unknown, fallback: string): string {
  if (!(error instanceof ApiError)) return fallback;
  const p = error.problem;
  const field = p?.errors?.[0];
  return p?.detail ?? (field ? `${field.path}: ${field.message}` : (p?.title ?? fallback));
}
